module.exports = __webpack_public_path__ + "static/media/wear.e9ef400.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/wear.mp4
// module id = eB2W
// module chunks = 3